import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { CountryDTO, CustomerDTO } from "@/model/data.model";
import { MeasurementUnitsDTO, CurrenciesDTO } from "@/model/data.model";
import store from "../vuex/store";
import { AxiosRequestConfigDef } from "@/event-bus";

export class GenericService {
  static getCountries() {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: store.getters.BASE_API_URL + "/tenants/countries",
      params: {}
    };

    return axios.request(config).then((res: AxiosResponse) => {
      const countries = res.data as CountryDTO[];

      return countries;
    });
  }

  static getMeasurementUnits() {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: store.getters.BASE_API_URL + "/tenants/measurement-units",
      params: {}
    };

    return axios.request(config).then((res: AxiosResponse) => {
      const mus = res.data as MeasurementUnitsDTO[];

      return mus;
    });
  }

  static getProformaMeasurementUnits() {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: store.getters.BASE_API_URL + "/shipments/proforma/measureUnits"
    };
    return axios
      .request(config)
      .then((res: any) => {
        return res.data;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }

  static getCurrencies() {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: store.getters.BASE_API_URL + "/tenants/currencies",
      params: {}
    };

    return axios.request(config).then((res: AxiosResponse) => {
      const currencies = res.data as CurrenciesDTO[];

      return currencies;
    });
  }

  getFilesList(microservice: string, absolutePath: string) {
    const filePath = absolutePath;
    const config: AxiosRequestConfigDef = {
      method: "GET",
      url: `${store.getters.BASE_API_URL}/${microservice}/files-storage/list`,
      params: {
        filePath
      },
      progress: false //do not show loader for MOL manual lookup
    };
    return axios.request(config).then(res => res.data as string);
  }

  getPresignedUrl(
    microserviceName: string,
    documentPath: string,
    forceDownload?: boolean,
    expTime?: boolean
  ): Promise<string> {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: `${store.getters.BASE_API_URL}/${microserviceName}/files-storage/presigned-url`,
      params: {
        path: documentPath,
        forceDownload: forceDownload,
        expTime: expTime
      }
    };
    return axios.request(config).then(res => res.data as string);
  }

  getStoreDate() {
    return axios
      .get(store.getters.BASE_API_URL + "/stores/date/current-date")
      .then((res: AxiosResponse<any>) => {
        if (res) {
          return res.data;
        } else {
          return null;
        }
      })
      .catch(err => {
        return Promise.reject(err.message);
      });
  }
}
